import type { JitsiTelehealthSession } from '../state/jitsiTelehealth.type'

export const isJitsiTelehealthAvailable = (value: unknown): value is JitsiTelehealthSession => {
  if (value === null || value === undefined || typeof value !== 'object') {
    return false
  }

  const candidate = value as Record<string, unknown>

  return (
    typeof candidate.patient_short_link === 'string' &&
    candidate.patient_short_link.length > 0 &&
    typeof candidate.doctor_embed_url === 'string' &&
    candidate.doctor_embed_url.length > 0
  )
}
